module.exports = __webpack_public_path__ + "img/airplane-2.cadbcee1.jpg";